export default __webpack_public_path__ + "static/media/ic_check_primary.dd06d5cb.svg";